

































































import {Component, Prop, Vue} from 'vue-property-decorator';
import { EventItem } from '@/store/models';
import user from '@/store/modules/user';

@Component
export default class StartDocumentItem extends Vue {
    @Prop() event: EventItem | undefined;

    async gotoItem() {
        if (!this.event) {
            return;
        }
        if (user.company.overview && user.company.overview.OrgNr !== this.event.OrgNr) {
            await user.clearCompany();
        }
        await user.setSelectedDocument(this.event.Id);
        await user.setSelectedDocumentBlob(null);
        const OrgNr: string = this.event.OrgNr;
        this.$router.push({ name: 'documents', params: { OrgNr } });
    }

    getType() {
        if (!this.event) { return ''; }

        if (this.event.SubType === 'valuation') {
            return 'Förenklad kassaflödesvärdering';
        } else if (this.event.SubType === 'company') {
            return 'Bolagsanalys';
        } else if (this.event.SubType === 'competitors') {
            return 'Konkurrentjämförelse';
        } else if (this.event.SubType === 'closingmeeting') {
            return 'Bokslutsmöte';
        } else if (this.event.SubType === 'preclosingmeeting') {
            return 'Inför Bokslut';
        } else if (this.event.SubType === 'futuremeeting') {
            return 'Framtidsmöte';
        } else if (this.event.SubType === 'yearendmeeting') {
            return 'Årsavslutsmöte';
        } else if (this.event.SubType === 'yearreview') {
            return 'Årsgenomgång';
        }

        return '';
    }
}
